module.exports = __webpack_public_path__ + "img/3.d26afe13.jpg";